// extracted by mini-css-extract-plugin
module.exports = {"itemRelBox":"Related_itemRelBox__Liecf","relTitle":"Related_relTitle__UsL_v"};